import React, { Component } from 'react';
import { Modal, Button, Spin } from 'antd';
import TableC from '../../../basicElement/TableC';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

export default class Detail extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        record: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    loadData = () => {
        const { record:{ customerCompanyId }, pagination:{ current, pageSize }, pagination } = this.state;
        const { params:{ jdeMainCode, investigationName } } = this.props;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryInvByCustomCompany, {
            offset: current,
            limit: pageSize,
            investigationName,
            jdeMainCode,
            customerCompanyId,
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            datas.forEach(( el, index) => {
                el.indexNum = index + 1;
            });
            this.setState({
                data:datas,
                loading: false,
                pagination,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 120,
        }, {
            title: 'PM姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 100,
        }, {
            title: 'PM工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 100,
        }];
        return columns;
    }
    
    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { visible, record, loading, data, pagination } = this.state;
        const { customerCompanyName } = record;
        return (
            <Modal
                title="项目明细"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width={900}
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div>
                        <p style={{ marginBottom: 10 }}>
                            <span style={{ paddingRight: 16 }}>客户名称:</span>
                            {customerCompanyName}
                        </p>
                        <TableC
                            data={data}
                            scrollY={450}
                            columns={this.getColumns()}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </Spin>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/Detail.js